import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/projected-ownership-force/actions';
import InputText from 'components/atoms/inputs/input-text';
import NumberHelper from 'helpers/number-helper';

class SubValue extends Component {
    onBlur(rawValue) {
        const value = this.prepareValue(rawValue);
        this.props.dispatch(Action.set('SubPercentOfProjectedOwnershipForce', value));
    }

    prepareValue(value) {
        const floatPrecision = 1;
        return NumberHelper.prepareFloat(value, floatPrecision, 100).limitByRange(0, 100, 0, 100).get();
    }

    render() {
        const {projectedOwnershipForce} = this.props;
        return <InputText percent value={projectedOwnershipForce.getSubValue()} onBlur={::this.onBlur} />;
    }
}

function mapStatesToProps(state) {
    return {
        projectedOwnershipForce: state.projectedOwnershipForce,
    };
}

export default connect(mapStatesToProps)(SubValue);
